import "~/misc/common";
import { p } from "~/misc/common";
import DeviceBase from "./device_base";
import { Chart, ChartDataset, ScatterDataPoint, TooltipItem } from "chart.js";
import { lineChartOptions, xTimeScaleOptions } from "~/misc/charts";

export default class extends DeviceBase {
  connect() {
    const el = this.element as HTMLDivElement;
    const threshold = Number(el.dataset.threshold ?? 0);

    this.connectBase({
      channel: "DeviceIfChannel",
      onEvent: (msg: string) => {
        if (msg.startsWith('value')) {
          value(msg.replace('value=', ''));
        }
      }
    });

    function value(msg: string) {
      const co2 = parseFloat(msg);
      if (!handle || !chart || Number.isNaN(co2)) return;

      handle.data.setValue(0, 1, co2);
      handle.formatter.format(handle.data, 1);
      handle.chart.draw(handle.data, handle.options);

      chart.data.datasets[0].data.push({
        x: new Date().getTime(),
        y: co2
      });
      chart.update();
    }

    type GaugeHandle = {
      chart: google.visualization.Gauge;
      data: google.visualization.DataTable;
      options: google.visualization.GaugeChartOptions;
      formatter: google.visualization.NumberFormat;
    };
    let handle: GaugeHandle | null = null;

    // Load Google Charts
    google.charts.load("current", { packages: ["gauge"] });
    google.charts.setOnLoadCallback(drawGauge);

    function drawGauge(): void {
      const options: google.visualization.GaugeChartOptions = {
        width: 300,//"100%",
        minorTicks: 10,
        majorTicks: ["400", "600", "800", "1000", "1200", "1400", "1600"],
        min: 400,
        max: 1600,
        yellowFrom: threshold - 100,
        yellowTo: threshold,
        redFrom: threshold,
        redTo: 1600
      };

      const element = document.getElementById("chart_co2");
      if (!element) return;

      const chart = new google.visualization.Gauge(element);

      const data = google.visualization.arrayToDataTable([
        ["Label", "Value"],
        ["ppm", 0]
      ]);

      const formatter = new google.visualization.NumberFormat({ pattern: "#" });
      formatter.format(data, 1);

      handle = { chart, data, options, formatter };
      chart.draw(data, options);
    };


    let chart: Chart<'line', ScatterDataPoint[], unknown> | null = null;
    const datasets = JSON.parse(el.dataset.datasets!) as ChartDataset<'line', ScatterDataPoint[]>[];
    p(datasets);
    const ctx = $('#line')[0] as HTMLCanvasElement;
    const options = Object.assign({}, lineChartOptions);
    options.scales = {
      x: { type: 'time', time: xTimeScaleOptions },
      y: {
        title: {
          display: true,
          text: 'ppm'
        },
        min: 0
      }
    };
    options.plugins = {
      tooltip: {
        callbacks: {
          label: function (tooltipItem: TooltipItem<'line'>) {
            const { x, y } = tooltipItem.raw as { x: number, y: number; };
            return Math.round(y).toFixed(1).replace(".0", "") + ' ppm';
          }
        }
      },
      annotation: {
        annotations: [
          {
            type: 'line',
            scaleID: 'y',
            value: threshold,
            borderColor: 'rgba(220, 57, 18, 0.5)',
            borderWidth: 2,
            label: {
              display: true,
              content: 'Limit'
            }
          }
        ]
      },
      zoom: {
        pan: {
          enabled: true,
          mode: 'x'
        },
        zoom: {
          wheel: { enabled: true },
          pinch: { enabled: true },
          mode: 'x'
          // drag: true // uncomment if you want drag zoom
        }
      }
    };

    chart = new Chart(ctx, {
      type: 'line',
      data: {
        datasets: datasets,
      },
      options: options
    });
  }
}
